import { render, staticRenderFns } from "./OrganismContent.vue?vue&type=template&id=74263bf0"
import script from "./OrganismContent.vue?vue&type=script&lang=ts"
export * from "./OrganismContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports